/* AUREA — interacciones propias (prefijo mt-) */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = window.Shopify && window.Shopify.designMode;

  /* ---------- Revelado al hacer scroll + cifras ---------- */
  var observer = null;
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.mt-reveal:not(.mt-visible)');
    if (!els.length) return;
    if (reduceMotion || designMode || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); countUp(el); });
      return;
    }
    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('mt-visible');
          countUp(entry.target);
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    }
    els.forEach(function (el) { observer.observe(el); });
  }

  function countUp(el) {
    var nums = el.matches('[data-mt-count]') ? [el] : el.querySelectorAll('[data-mt-count]');
    nums.forEach(function (n) {
      if (n.dataset.mtDone) return;
      n.dataset.mtDone = '1';
      var target = parseFloat(n.dataset.mtCount);
      if (isNaN(target) || reduceMotion || designMode || target === 0) { n.textContent = n.dataset.mtCount; return; }
      var dur = 1600, start = null;
      function step(ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        n.textContent = Math.round(target * eased);
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    });
  }

  /* ---------- Galería de producto ---------- */
  function initGaleria(root) {
    (root || document).querySelectorAll('[data-mt-galeria]').forEach(function (g) {
      if (g.dataset.mtInit) return;
      g.dataset.mtInit = '1';
      var main = g.querySelector('[data-mt-principal]');
      var minis = Array.prototype.slice.call(g.querySelectorAll('[data-mt-mini]'));
      if (!main || minis.length < 2) return;
      var actual = 0;
      function mostrar(i) {
        actual = (i + minis.length) % minis.length;
        var m = minis[actual];
        main.classList.add('mt-cambiando');
        setTimeout(function () {
          main.src = m.dataset.src;
          main.srcset = m.dataset.srcset || '';
          main.alt = m.dataset.alt || '';
          main.classList.remove('mt-cambiando');
        }, 200);
        minis.forEach(function (x, k) { x.classList.toggle('is-active', k === actual); x.setAttribute('aria-current', k === actual); });
        m.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      }
      minis.forEach(function (m, i) { m.addEventListener('click', function () { mostrar(i); }); });
      var prev = g.querySelector('[data-mt-prev]'), next = g.querySelector('[data-mt-next]');
      if (prev) prev.addEventListener('click', function () { mostrar(actual - 1); });
      if (next) next.addEventListener('click', function () { mostrar(actual + 1); });
      // Deslizar con el dedo
      var x0 = null;
      main.parentElement.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      main.parentElement.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) mostrar(actual + (dx < 0 ? 1 : -1));
        x0 = null;
      });
    });
  }

  /* ---------- Selector de cantidad ---------- */
  function initCantidad(root) {
    (root || document).querySelectorAll('[data-mt-cantidad]').forEach(function (c) {
      if (c.dataset.mtInit) return;
      c.dataset.mtInit = '1';
      var input = c.querySelector('input');
      c.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(input.value, 10) || 1;
          v = Math.max(1, v + parseInt(b.dataset.paso, 10));
          input.value = v;
        });
      });
    });
  }

  /* ---------- Tarjetas 1 set / pack de 2 ---------- */
  function initPacks(root) {
    (root || document).querySelectorAll('[data-mt-packs]').forEach(function (packs) {
      if (packs.dataset.mtInit) return;
      packs.dataset.mtInit = '1';
      var scope = packs.closest('[data-mt-producto]') || document;
      var radios = packs.querySelectorAll('input[type="radio"]');
      function aplicar() {
        var sel = packs.querySelector('input[type="radio"]:checked');
        if (!sel) return;
        radios.forEach(function (r) { r.closest('.mt-pack').classList.toggle('is-selected', r === sel); });
        scope.querySelectorAll('[data-mt-pack-cantidad]').forEach(function (i) { i.value = sel.value; });
        document.querySelectorAll('[data-mt-pack-total]').forEach(function (p) { p.textContent = sel.dataset.total; });
      }
      radios.forEach(function (r) { r.addEventListener('change', aplicar); });
      aplicar();
    });
  }

  /* ---------- Opiniones: "Leer más", "Ver más" y foto ampliada ---------- */
  function initResenas(root) {
    (root || document).querySelectorAll('[data-mt-resenas]').forEach(function (sec) {
      if (sec.dataset.mtInit) return;
      sec.dataset.mtInit = '1';
      function revisarTextos() {
        sec.querySelectorAll('[data-mt-resena-texto]').forEach(function (t) {
          var btn = t.parentElement.querySelector('[data-mt-leer]');
          if (btn && !t.classList.contains('is-abierto')) btn.hidden = t.scrollHeight <= t.clientHeight + 2;
        });
      }
      sec.addEventListener('click', function (e) {
        var leer = e.target.closest('[data-mt-leer]');
        if (leer) {
          var t = leer.parentElement.querySelector('[data-mt-resena-texto]');
          var abierto = t.classList.toggle('is-abierto');
          leer.textContent = abierto ? 'Leer menos' : 'Leer más';
          return;
        }
        var mas = e.target.closest('[data-mt-ver-mas]');
        if (mas) {
          sec.querySelectorAll('.mt-resena.is-extra').forEach(function (r) { r.hidden = false; });
          mas.parentElement.remove();
          revisarTextos();
          return;
        }
        var foto = e.target.closest('[data-mt-foto]');
        var dlg = sec.querySelector('[data-mt-lightbox]');
        if (foto && dlg && dlg.showModal) {
          dlg.querySelector('[data-mt-lightbox-img]').src = foto.dataset.mtFoto;
          dlg.showModal();
          return;
        }
        if (dlg && (e.target === dlg || e.target.closest('[data-mt-lightbox-cerrar]'))) dlg.close();
      });
      revisarTextos();
      window.addEventListener('resize', revisarTextos, { passive: true });
    });
  }

  /* ---------- Variantes ---------- */
  function initVariantes(root) {
    (root || document).querySelectorAll('[data-mt-variantes]').forEach(function (wrap) {
      if (wrap.dataset.mtInit) return;
      wrap.dataset.mtInit = '1';
      var dataEl = wrap.querySelector('script[type="application/json"]');
      if (!dataEl) return;
      var variants = JSON.parse(dataEl.textContent);
      var scope = wrap.closest('[data-mt-producto]') || document;
      var selects = wrap.querySelectorAll('select');
      selects.forEach(function (s) {
        s.addEventListener('change', function () {
          var opts = Array.prototype.map.call(selects, function (x) { return x.value; });
          var v = variants.find(function (vv) { return vv.options.every(function (o, i) { return o === opts[i]; }); });
          var btns = scope.querySelectorAll('[data-mt-boton]');
          if (!v) {
            btns.forEach(function (b) { b.disabled = true; b.querySelector('span').textContent = b.dataset.textoNoDisponible; });
            return;
          }
          scope.querySelectorAll('form[data-type="add-to-cart-form"] input[name="id"]').forEach(function (i) { i.value = v.id; });
          scope.querySelectorAll('[data-mt-precio]').forEach(function (p) { p.textContent = formatMoney(v.price, p.dataset.formato); });
          scope.querySelectorAll('[data-mt-precio-antes]').forEach(function (p) {
            p.hidden = !(v.compare_at_price > v.price);
            if (!p.hidden) p.textContent = formatMoney(v.compare_at_price, p.dataset.formato);
          });
          btns.forEach(function (b) {
            b.disabled = !v.available;
            b.removeAttribute('aria-disabled');
            b.querySelector('span').textContent = v.available ? b.dataset.textoComprar : b.dataset.textoAgotado;
          });
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
          if (v.featured_image) {
            var main = scope.querySelector('[data-mt-principal]');
            if (main) { main.src = v.featured_image.src; main.srcset = ''; }
          }
        });
      });
    });
  }

  function formatMoney(cents, formato) {
    var value = (cents / 100).toFixed(2);
    var conComa = value.replace('.', ',');
    var f = formato || '{{amount_with_comma_separator}} €';
    return f
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, conComa)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(cents / 100))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
      .replace(/\{\{\s*amount\s*\}\}/, value);
  }

  /* ---------- Barra de compra fija (móvil) ---------- */
  function initBarra(root) {
    var barra = (root || document).querySelector('[data-mt-barra]');
    if (!barra || barra.dataset.mtInit) return;
    barra.dataset.mtInit = '1';
    var principal = document.querySelector('[data-mt-compra-principal]');
    if (!principal) return;
    var footer = document.querySelector('.mt-footer');
    var pendiente = false;
    function update() {
      pendiente = false;
      var pasada = principal.getBoundingClientRect().bottom < 0;
      var pie = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;
      barra.classList.toggle('is-visible', pasada && !pie);
    }
    window.addEventListener('scroll', function () {
      if (pendiente) return;
      pendiente = true;
      requestAnimationFrame(update);
    }, { passive: true });
    update();
    var btn = barra.querySelector('button');
    if (btn) btn.addEventListener('click', function () {
      var b = principal.querySelector('button[type="submit"]');
      if (b) b.click();
    });
  }

  function initAll(root) {
    initReveal(root);
    initGaleria(root);
    initCantidad(root);
    initPacks(root);
    initResenas(root);
    initVariantes(root);
    initBarra(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
